<script setup lang="ts">
import { computed, ref } from "vue";

interface Props {
  prefix?: string;
  name: string;
  color?: string;
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  prefix: "icon",
  color: "",
  size: 20,
});

const symbolId = computed(() => `#${props.prefix}-${props.name}`);
</script>

<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 20 20"
    :width="size"
    :height="size"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-inline--icon"
    :style="{
      color: props.color,
    }"
  >
    <use :href="symbolId" />
  </svg>
</template>

<style scoped>
/* Добавь стили, если нужно */
</style>
